//#region src/extensions/list-extension/list-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.BulletList = "bulletList", e.OrderedList = "orderedList", e;
}({});
//#endregion
export { e as ListEnum };
